<template>
  <div class="page">
    <app-title :page="'Estimates'">
      <div
        slot="content"
        class="flex-sm justify-content-space-between flex-end">
        <p class="font-size-4 mb1">Let&rsquo;s estimate your tasks rationally</p>
      </div>
    </app-title>

    <section
      v-if="estimates.length"
      class="grid mb-margin">
      <div
        v-if="estimates.length > 15"
        class="align-right"><router-link
          :class="'button accent large-button full-button_mb mt2 mb0'"
          :to="{ name: 'newEstimate' }">New estimate</router-link></div>
      <div class="subtle px2 py1 my1">
        <lw-table
          :type="'lined'"
          :headings="[
            'Project',
            'Client',
            'Estimate range'
          ]"
          :widths="[
            '20',
            '60',
            '20'
          ]"
          :alignment="[
            'left',
            'left',
            'right',
          ]"
        >
          <tr
            v-for="estimate in estimates"
            :key="estimate.id">
            <td
              class="title"
              data-label="Project"><router-link :to="{ name: 'estimate', params: { id: estimate.id }}">{{ estimate.project }}</router-link></td>
            <td data-label="Client">{{ estimate.client }}</td>
            <td
              v-if="estimate.showRedFlags"
              class="numerical"
              data-label="Estimate range">{{ estimate.lowMidPrice | currency }} &ndash; {{ estimate.midHighPrice | currency }}</td>
            <td
              v-else
              class="numerical"
              data-label="Estimate range">{{ estimate.lowPrice | currency }} &ndash; {{ estimate.highPrice | currency }}</td>
          </tr>
        </lw-table>
      </div>
      <div class="align-right"><router-link
        :class="'button accent large-button full-button_mb'"
        :to="{ name: 'newEstimate' }">New estimate</router-link></div>
    </section>
    <section
      v-else
      class="grid mb-margin">
      <div><router-link
        :class="'button accent large-button full-button_mb mt2'"
        :to="{ name: 'newEstimate' }">Make your first estimate</router-link></div>
    </section>
    <transition
      name="slide-top"
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import page from '../mixins/page'
import Table from '../livewires/Table'
import { truncate } from '../mixins/truncate'

export default {
  components: {
    lwTable: Table
  },
  mixins: [ page, truncate ],
  data () {
    return {
      alert: '',
      alertType: ''
    }
  },
  computed: {
    ...mapGetters([
      'organization',
      'estimates'
    ]),
    loading () {
      return this.$store.getters.estimatesLoading
    }
  }
}
</script>
